import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './components/home/home.component';
import { ServiceLoginComponent } from './components/serviceLogin/serviceLogin.component';
import { PlcViewerComponent } from './components/plcviewer/plcviewer.component';
import { ScriptViewerComponent } from './components/scriptviewer/scriptviewer.component';
import { SqlViewerComponent } from './components/sqlviewer/sqlviewer.component';
import { ConfigurationViewerComponent } from './components/configurationviewer/configurationviewer.component';
import { TestPageComponent } from './components/testpage/testpage.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'home', component: HomeComponent },
  { path: 'login', component: ServiceLoginComponent },
  { path: 'plcviewer', component: PlcViewerComponent },
  { path: 'scriptviewer', component: ScriptViewerComponent },
  { path: 'sqlviewer', component: SqlViewerComponent },
  { path: 'configuration', component: ConfigurationViewerComponent },
  { path: 'testpage', component: TestPageComponent }
];

export const APP_ROUTES = RouterModule.forRoot(routes);